import type { TradeLogicComparisonOperatorV2 } from '@/types/appRouter';
import type { ScorecardFeatureRow, ScorecardRuleRole, ThresholdsMeta } from './types';

export const defaultThresholds: ThresholdsMeta = { minMatchedRules: 1, minPositiveMatchedRules: 0 };

export const scorecardBarDurations = ['1m', '3m', '5m', '15m', '30m', '60m', '120m', '180m', '240m', '1d', '1w', '1mo'] as const;
export type ScorecardBarDuration = (typeof scorecardBarDurations)[number];

export const numericValueKinds = new Set<ScorecardFeatureRow['valueKind']>(['number', 'integer']);

export const thresholdOperators: TradeLogicComparisonOperatorV2[] = ['>', '>=', '<', '<='];

export const ruleRoleOptions: { value: ScorecardRuleRole; label: string }[] = [
    { value: 'boost', label: 'Boost' },
    { value: 'penalty', label: 'Penalty' },
    { value: 'veto', label: 'Veto' }
];
